import { __awaiter } from 'tslib';
import { Component, Inject, Injectable, NgModule } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from '@angular/material/form-field';
import * as ɵngcc5 from '@angular/material/input';
import * as ɵngcc6 from '@angular/forms';

function CoolDialogComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2, "To confirm please type ");
    ɵngcc0.ɵɵelementStart(3, "span", 8);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " into the input below to enable confirm button. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 9);
    ɵngcc0.ɵɵelementStart(7, "mat-form-field", 10);
    ɵngcc0.ɵɵelementStart(8, "input", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function CoolDialogComponent_div_4_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.confirmInput = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.textConfirmation);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate1("placeholder", "Write '", ctx_r0.textConfirmation, "' to enable confirm button");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.confirmInput);
} }
function CoolDialogComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function CoolDialogComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onCancelClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.cancelActionButtonText, " ");
} }
class CoolDialogComponent {
    constructor(_dialogRef, _dialogConfig) {
        this._dialogRef = _dialogRef;
        this._dialogConfig = _dialogConfig;
    }
    ngOnInit() {
        this.titleText = this._dialogConfig.titleText;
        this.questionText = this._dialogConfig.questionText;
        this.confirmActionButtonText = this._dialogConfig.confirmActionButtonText || 'Ok';
        this.cancelActionButtonText = this._dialogConfig.cancelActionButtonText || 'Cancel';
        this.confirmActionButtonColor = this._dialogConfig.confirmActionButtonColor || 'primary';
        this.showCancelActionButton = this._dialogConfig.showCancelActionButton || true;
        this.textConfirmation = this._dialogConfig.textConfirmation;
    }
    onCancelClick() {
        this._dialogRef.close({
            isConfirmed: false
        });
    }
    onConfirmClick() {
        this._dialogRef.close({
            isConfirmed: true
        });
    }
}
CoolDialogComponent.ɵfac = function CoolDialogComponent_Factory(t) { return new (t || CoolDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
CoolDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CoolDialogComponent, selectors: [["cool-dialog"]], decls: 10, vars: 7, consts: [["mat-dialog-title", ""], ["mat-dialog-content", ""], ["class", "mt-3", 4, "ngIf"], ["mat-dialog-actions", ""], [1, "w-100", "text-right", "mt-3"], ["mat-raised-button", "", "cdkFocusInitial", "", 3, "click", 4, "ngIf"], ["mat-raised-button", "", 3, "disabled", "color", "click"], [1, "mt-3"], [1, "bg-secondary", "text-warning", "px-2"], [1, "mt-2"], [1, "w-100"], ["name", "confirm-input", "matInput", "", 3, "ngModel", "placeholder", "ngModelChange"], ["mat-raised-button", "", "cdkFocusInitial", "", 3, "click"]], template: function CoolDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, CoolDialogComponent_div_4_Template, 9, 3, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵtemplate(7, CoolDialogComponent_button_7_Template, 2, 1, "button", 5);
        ɵngcc0.ɵɵelementStart(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function CoolDialogComponent_Template_button_click_8_listener() { return ctx.onConfirmClick(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.titleText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.questionText, "\n");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.textConfirmation);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCancelActionButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("color", ctx.confirmActionButtonColor);
        ɵngcc0.ɵɵproperty("disabled", ctx.textConfirmation && ctx.confirmInput !== ctx.textConfirmation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.confirmActionButtonText, " ");
    } }, directives: [ɵngcc1.MatDialogTitle, ɵngcc1.MatDialogContent, ɵngcc2.NgIf, ɵngcc1.MatDialogActions, ɵngcc3.MatButton, ɵngcc4.MatFormField, ɵngcc5.MatInput, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel], styles: ["mat-dialog-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:10px}mat-dialog-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{margin-right:0}*[_ngcontent-%COMP%]{box-sizing:border-box}.mt-3[_ngcontent-%COMP%]{margin-top:1rem}.mt-2[_ngcontent-%COMP%]{margin-top:.5rem}.w-100[_ngcontent-%COMP%]{width:100%}.px-2[_ngcontent-%COMP%]{padding-right:.5rem}.text-right[_ngcontent-%COMP%]{text-align:right}.bg-secondary[_ngcontent-%COMP%]{background-color:#6c757d}.text-warning[_ngcontent-%COMP%]{color:#ffc107}"] });
CoolDialogComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoolDialogComponent, [{
        type: Component,
        args: [{
                selector: 'cool-dialog',
                template: "<h1 mat-dialog-title>{{ titleText }}</h1>\n\n<div mat-dialog-content>\n  {{ questionText }}\n</div>\n\n<div *ngIf=\"textConfirmation\" class=\"mt-3\">\n  <div>To confirm please type <span class=\"bg-secondary text-warning px-2\">{{ textConfirmation }}</span> into the input\n    below to enable confirm button.\n  </div>\n  <div class=\"mt-2\">\n    <mat-form-field class=\"w-100\">\n      <input name=\"confirm-input\"\n             [(ngModel)]=\"confirmInput\"\n             matInput\n             placeholder=\"Write '{{ textConfirmation }}' to enable confirm button\">\n    </mat-form-field>\n  </div>\n</div>\n\n<div mat-dialog-actions>\n  <div class=\"w-100 text-right mt-3\">\n    <button *ngIf=\"showCancelActionButton\"\n            (click)=\"onCancelClick()\"\n            mat-raised-button\n            cdkFocusInitial>\n      {{ cancelActionButtonText }}\n    </button>\n\n    <button (click)=\"onConfirmClick()\"\n            [disabled]=\"textConfirmation && confirmInput !== textConfirmation\"\n            color=\"{{ confirmActionButtonColor }}\" mat-raised-button>\n      {{ confirmActionButtonText }}\n    </button>\n  </div>\n</div>\n",
                styles: ["mat-dialog-actions button{margin-right:10px}mat-dialog-actions button:last-child{margin-right:0}*{box-sizing:border-box}.mt-3{margin-top:1rem}.mt-2{margin-top:.5rem}.w-100{width:100%}.px-2{padding-right:.5rem}.text-right{text-align:right}.bg-secondary{background-color:#6c757d}.text-warning{color:#ffc107}"]
            }]
    }], function () { return [{ type: ɵngcc1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class CoolDialogService {
    constructor(_dialog) {
        this._dialog = _dialog;
    }
    showDialog(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialogRef = this._dialog.open(CoolDialogComponent, {
                disableClose: true,
                data: config,
            });
            const result = yield dialogRef.afterClosed().toPromise();
            return result || {
                isConfirmed: false,
            };
        });
    }
}
CoolDialogService.ɵfac = function CoolDialogService_Factory(t) { return new (t || CoolDialogService)(ɵngcc0.ɵɵinject(ɵngcc1.MatDialog)); };
CoolDialogService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CoolDialogService, factory: CoolDialogService.ɵfac });
CoolDialogService.ctorParameters = () => [
    { type: MatDialog }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoolDialogService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.MatDialog }]; }, null); })();

class CoolDialogsModule {
    static forRoot() {
        return {
            ngModule: CoolDialogsModule,
            providers: [
                CoolDialogService,
            ],
        };
    }
}
CoolDialogsModule.ɵfac = function CoolDialogsModule_Factory(t) { return new (t || CoolDialogsModule)(); };
CoolDialogsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CoolDialogsModule });
CoolDialogsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MatButtonModule,
            MatDialogModule,
            MatFormFieldModule,
            MatInputModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CoolDialogsModule, { declarations: function () { return [CoolDialogComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule]; }, exports: function () { return [CoolDialogComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoolDialogsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatButtonModule,
                    MatDialogModule,
                    MatFormFieldModule,
                    MatInputModule,
                ],
                declarations: [
                    CoolDialogComponent,
                ],
                exports: [
                    CoolDialogComponent,
                ],
                entryComponents: [
                    CoolDialogComponent,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of dialogs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CoolDialogComponent, CoolDialogService, CoolDialogsModule };

//# sourceMappingURL=angular-cool-dialogs.js.map